import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Tooltip from '@material-ui/core/Tooltip';
import TabPanel from './TabPanel';
import EditDelegate from '../molecules/delegates/EditDelegate';
import ListUserTriggers from '../molecules/user_triggers/ListUserTriggers';
import CreateUserTrigger from '../molecules/user_triggers/CreateUserTrigger';
import EditUserTrigger from '../molecules/user_triggers/EditUserTrigger';
import CreateRoutingRule from '../molecules/routing_rules/CreateRoutingRule';
import { handleSnackBar, invokePostService, setTabOnFocus, updateAiAssistant } from '../../store/global/actions';
import { marginBottomForBreadCrumb } from '../../config/styles';
import BreadCrumb from '../atoms/breadcrumb/';
import { getAiAssistantLoading, getBottomDrawerStatus, getTabOnFocus } from '../../store/global/selectors';
import Divider from '@material-ui/core/Divider';
import ListRoutingRules from '../molecules/routing_rules/ListRoutingRules';
import EditRoutingRule from '../molecules/routing_rules/EditRoutingRule';
import DeleteRoutingRuleAlert from '../molecules/alerts/DeleteRoutingRuleAlert';
import DeleteUserTriggerAlert from '../molecules/alerts/DeleteUserTriggerAlert';
import ListTransactions from '../molecules/transactions/ListTransactions';
import DeleteDelegateAlert from '../molecules/alerts/DeleteDelegateAlert';
import IconButton from '@material-ui/core/IconButton';
import { setFocusElement, toggleRightDrawer, reRenderInfoBuilder, setReRender, triggerTour } from '../../store/global/actions'
import DeleteIcon from '@material-ui/icons/Delete';
import AllEvents from '../molecules/events/AllEvents';
import ExtendUTFields from '../molecules/user_triggers/ExtendUTFields';
import DelegateProfile from '../molecules/delegates/DelegateProfile';
import { invokeGetService } from '../../store/global/actions';
import { useBottomDrawer } from '../../hooks/useBottomDrawer';
import { Box, CircularProgress, Link, makeStyles } from '@material-ui/core';

const svgIcons = {
   aiTool: `<svg width="100pt" height="100pt" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <path d="m68.688 53.613c1.5234-0.54297 2.543-1.9961 2.543-3.6133s-1.0234-3.0703-2.5391-3.6133l-6.9688-2.5117c-6.8828-2.4766-12.25-7.8516-14.73-14.73l-2.5117-6.9688c-0.54688-1.5156-1.9961-2.5391-3.6055-2.5391h-0.003906c-1.6133 0-3.0625 1.0195-3.6133 2.5391l-2.5078 6.9688c-2.4805 6.8828-7.8516 12.254-14.734 14.73l-6.9609 2.5117c-1.5234 0.54688-2.5469 1.9961-2.5469 3.6133s1.0234 3.0664 2.5391 3.6133l6.9688 2.5117c6.8828 2.4766 12.25 7.8477 14.73 14.73l2.5117 6.9727c0.54688 1.5156 2 2.5352 3.6133 2.5352h0.003906c1.6133 0 3.0625-1.0234 3.6055-2.5391l2.5117-6.9688c2.4766-6.8828 7.8516-12.25 14.73-14.73zm-9.082-3.3711c-8.6406 3.1133-15.383 9.8516-18.492 18.492l-0.24219 0.67578-0.24219-0.67578c-3.1172-8.6406-9.8555-15.383-18.492-18.492l-0.67578-0.24219 0.67578-0.24219c8.6406-3.1133 15.383-9.8516 18.492-18.492l0.24219-0.67578 0.24219 0.67578c3.1133 8.6406 9.8516 15.383 18.492 18.492l0.67578 0.24219z" fill="#2c3b4a"/>
        <path d="m57.961 23.32 3.5273 1.2734c3.0547 1.1016 5.4297 3.4805 6.5312 6.5312l1.2695 3.5234c0.49609 1.3828 1.8164 2.3086 3.2812 2.3086 1.4648 0 2.7891-0.92969 3.2812-2.3047l1.2734-3.5273c1.1016-3.0547 3.4805-5.4336 6.5312-6.5312l3.5312-1.2734c1.3711-0.49609 2.3008-1.8125 2.3047-3.2734 0.003906-1.4609-0.91406-2.7812-2.3047-3.2891l-3.5312-1.2656c-3.0508-1.1016-5.4297-3.4805-6.5312-6.5312l-1.2734-3.5273c-0.49609-1.3828-1.8125-2.3086-3.2773-2.3086-1.4688 0-2.7891 0.92969-3.2812 2.3047l-1.2734 3.5273c-1.1016 3.0547-3.4805 5.4297-6.5312 6.5312l-3.5391 1.2734c-1.375 0.5-2.3008 1.8203-2.2969 3.2852 0.007812 1.4648 0.93359 2.7812 2.3086 3.2734zm14.613-9.3984c1.4805 2.5391 3.5859 4.6406 6.1172 6.1172-2.5391 1.4805-4.6406 3.5859-6.1172 6.1172-1.4805-2.5352-3.5859-4.6406-6.1172-6.1172 2.5352-1.4805 4.6367-3.582 6.1172-6.1172z" fill="#2c3b4a"/>
        <path d="m87.184 76.68-3.5273-1.2734c-3.0508-1.1016-5.4297-3.4805-6.5312-6.5312l-1.2734-3.5273c-0.49609-1.3789-1.8164-2.3047-3.2812-2.3047-1.4688 0-2.7891 0.92969-3.2812 2.3047l-1.2734 3.5273c-1.1016 3.0547-3.4805 5.4336-6.5312 6.5312l-3.5234 1.2695c-1.3789 0.49219-2.3047 1.8125-2.3086 3.2734-0.003906 1.4609 0.91797 2.7852 2.3047 3.2891l3.5273 1.2734c3.0547 1.1016 5.4336 3.4766 6.5312 6.5312l1.2695 3.5234c0.50391 1.3789 1.8203 2.3086 3.2891 2.3086s2.7891-0.92969 3.2812-2.3047l1.2734-3.5273c1.1016-3.0508 3.4805-5.4297 6.5312-6.5312l3.543-1.2734c1.3711-0.50391 2.293-1.8203 2.2891-3.2852 0-1.4648-0.93359-2.7773-2.3086-3.2734zm-14.609 9.3984c-1.4805-2.5391-3.5859-4.6406-6.1172-6.1172 2.5352-1.4805 4.6406-3.5859 6.1172-6.1172 1.4805 2.5352 3.5859 4.6406 6.1172 6.1172-2.5312 1.4805-4.6367 3.582-6.1172 6.1172z" fill="#2c3b4a"/>
        </svg>`,
    aiData: `<?xml version="1.0" encoding="UTF-8"?>
            <svg width="100pt" height="100pt" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path d="m55.148 77.379c-3.0312 0.42969-6.6484 0.62109-11.719 0.62109-19.719 0-30.039-4.7188-30.969-6.6719v-18.488c8.2812 3.8984 21.711 5.1484 30.969 5.1484 6.3594 0 11.23-0.32031 15.32-1.0195 2.0312-0.33984 3.3906-2.2695 3.0508-4.3008-0.33984-2.0312-2.2695-3.3906-4.3008-3.0508-3.6797 0.62109-8.1484 0.91016-14.078 0.91016-19.719 0-30.039-4.7188-30.969-6.6719v-12.77c8.2812 3.8984 21.711 5.1484 30.969 5.1484 9.2617 0 22.699-1.25 30.98-5.1484v10.391c0 2.0586 1.6719 3.7305 3.7305 3.7305 2.0586 0 3.7305-1.6719 3.7305-3.7305l-0.003906-19.246s-0.011719-0.078125-0.011719-0.10938c-0.17188-10.98-24.199-13.91-38.422-13.91-14.215 0-38.414 2.9492-38.414 14.02v49.211c0 11.07 24.16 14.02 38.43 14.02 5.4297 0 9.3711-0.21094 12.762-0.69922 2.0391-0.28906 3.4609-2.1719 3.1719-4.2109-0.28906-2.0391-2.1914-3.4609-4.2109-3.1719zm-11.719-61.73c19.391 0 29.691 4.5586 30.922 6.5703-1.2305 2.0117-11.531 6.5703-30.922 6.5703-19.391 0-29.691-4.5586-30.922-6.5703 1.2305-2.0117 11.531-6.5703 30.922-6.5703zm49.238 49.891-12.281-5-4.7188-12.391c-0.53906-1.4297-1.9102-2.3789-3.4414-2.3984h-0.039062c-1.5195 0-2.8789 0.92188-3.4492 2.3203l-5 12.281-12.391 4.7188c-1.4297 0.53906-2.3789 1.9102-2.3984 3.4414s0.89844 2.9219 2.3203 3.4883l12.281 5 4.7188 12.391c0.53906 1.4297 1.9102 2.3789 3.4414 2.3984h0.039062c1.5195 0 2.8789-0.92187 3.4492-2.3203l4.9883-12.281 12.391-4.7188c1.4297-0.53906 2.3789-1.9102 2.3984-3.4414 0.019532-1.5312-0.89844-2.9219-2.3203-3.4883zm-16.641 5.2617c-0.96875 0.37109-1.7383 1.1211-2.1289 2.0781l-2.0391 5.0117-1.9297-5.0586c-0.37109-0.96875-1.1211-1.7383-2.0781-2.1289l-5.0117-2.0391 5.0586-1.9297c0.96875-0.37109 1.7383-1.1211 2.1289-2.0781l2.0391-5.0117 1.9297 5.0586c0.37109 0.96875 1.1211 1.7383 2.0781 2.1289l5.0117 2.0391z" fill="#343e4f"/>
            </svg>
            `
}


const useStyles = makeStyles((theme) => ({
    linkContainer: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        paddingLeft: 14,
    },
    link: {
        cursor: "pointer",
        fontWeight: 500,
        fontSize: 14,
        color: "#2e5e8d", // Blue color
        textDecoration: "underline",
        "&:hover": {
          textDecoration: "underline",
          color: theme.palette.primary.dark,
        },
        "&:focus": {
            outline: "none",
        },

        "&:active": {
            outline: "none",
        },
      },
    icon: {
        fontSize: 24,
        /* border: 1px solid black; */
        width: 22,
        height: 22,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        cursor: "pointer",
        color: "#000"
    },
    aiLoader: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingLeft: 14,
    },
    loaderText: {
        paddingLeft: 14
    }
}));



export default function Delegate({ element, bottomDrawer }) {
   
    const classes = useStyles();
    const dispatch = useDispatch();
    const tabOnFocus = useSelector(getTabOnFocus);
    const isAIAssistantActive = useSelector(getAiAssistantLoading);

    const [action, setAction] = useState({});
    const [showDeleteAlert, setShowDeleteAlert] = useState(true);
    const [breadCrumbItem, setBreadCrumbItem] = useState([])
    const [isRrdefRequired, setIsRrdefRequired] = useState(null);
    const [openTab, setOpenTab] = useState(0)
    const [hideCreateRrdfButton, setHideCreateRrdfButton] = useState(false);
    const [associatedTransactions, setAssciatedTransactions] = useState([]);
    const [databaseProfileSchema, setDatabaseProfileSchema] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const bottomDrawerConfig = useBottomDrawer()
    const {activeTab, setActiveTab, setTabConfig} = bottomDrawerConfig || {}

    const controlDelegate = element.type === "controller_delegate" ? true : false;

    const showGenerateDatabaseProfile = element.protocol === "mysql_delegate" ? true : false;

    const detailsBC = [
        { label: 'Delegate', url: null },
        { label: element.name, url: null }
    ];

    const rrdefItem = [
        { label: 'Routing Rules', url: null }
    ]

    const userTriggerItem = [
        { label: 'User Triggers', url: null }
    ]

    useEffect(() => {
        if (action.item?.name) {
            setBreadCrumbItem([{ label: action.item?.name, url: null }]);
        }
    }, [action])


    useEffect(() => {
        if(bottomDrawer){
            setActiveTab(tabOnFocus)
        }else{
            setOpenTab(tabOnFocus);
        }
        setAction({})
        setBreadCrumbItem([])
    }, [tabOnFocus])

    useEffect(() => { 
        Promise.all([
            dispatch(invokeGetService('getRrdefPlatformSchema', [element.protocol])),
            dispatch(invokeGetService('getAssociatedTransactions', [element.id, 1]))
        ]).then(([routingRuleSchema, associatedTransactions]) => {
            
            
            if (routingRuleSchema.status && routingRuleSchema.data) {
                if (routingRuleSchema.data.length > 0) {
                    setIsRrdefRequired(true);
                } else {
                    setIsRrdefRequired(false);
                }
            } else {
                setIsRrdefRequired(false);
            }

            if(associatedTransactions?.status ){
                setHideCreateRrdfButton(associatedTransactions?.data && associatedTransactions?.data?.length > 0 ? false : true);
            }

        }).catch(error => {
            console.error(`Fetching clusterlet details failed. ${error}`);
        })

    }, [element])


    const onCompletion = (type, action) => {
        if (action !== undefined) {
            switch (action) {
                case 'add':
                    dispatch(handleSnackBar({ open: true, message: `${type} created`, severity: "success" }));
                    break;

                case 'edit':
                    dispatch(handleSnackBar({ open: true, message: `${type} updated`, severity: "success" }));
                    if (type !== 'Routing rule' && type !== 'User trigger') {
                        dispatch(reRenderInfoBuilder());
                        dispatch(setReRender());
                    }
                    if (process.env.REACT_APP_AUTO_CLOSE === 'true') {
                        dispatch(toggleRightDrawer());
                    }
                    break;

                case 'delete':
                    dispatch(handleSnackBar({ open: true, message: `${type} deleted`, severity: "success" }));
                    if (type !== 'Routing rule' && type !== 'User trigger') {
                        dispatch(toggleRightDrawer());
                        dispatch(setReRender());
                        dispatch(setFocusElement({}));
                        dispatch(reRenderInfoBuilder());
                    }

                    break;

                case 'clone':
                    dispatch(handleSnackBar({ open: true, message: `${type} cloned`, severity: "success" }));
                    break;
                default:
                    break;
            }
            setAction({})
            setBreadCrumbItem([])
        }
    }

    const onClose = () => {
        setAction({})
        setBreadCrumbItem([])
    }

    const handleClickDelete = () => {
        setShowDeleteAlert(true);
        setAction({ action: 'delete_delegate' });
    }


    const generateDatabaseTablesWithAI  = () => {
        const delegate = {
            _id: element.id,
            name: element.name,
            icon: element?.icon,
            attributes: {
                desc: element.desc,
                type: element.protocol
            }
        }
        const isCreate = databaseProfileSchema ? false : true;
        dispatch(updateAiAssistant({aiAssistantOpen: true, isMinimized: false, step: "database_profile", requestContext: {action: "schema", isCreate, entity: delegate, entityType: 'database_profile'}}));
    }

    const generateDatabaseSampleDataWithAI  = () => {
        const delegate = {
            _id: element.id,
            name: element.name,
            icon: element?.icon,
            attributes: {
                desc: element.desc,
                type: element.protocol
            }
        }
        dispatch(updateAiAssistant({aiAssistantOpen: true, isMinimized: false, step: "database_profile", requestContext: {action: "data", entity: delegate, entityType: 'database_profile'}}));
    }

    
    useEffect(() => {
        if(bottomDrawer){
            const tabs = [
                {
                    label: "Delegate",
                    tourId: "delegate-tab"
                },
                {
                    label: "Events",
                    tourId: "delegate-event-tab"
                },
                {
                    label: "Transactions",
                    tourId: "delegate-transaction-tab"
                }
            ]
    
            if(!controlDelegate){
                tabs.push({
                    label: "Routing Rules",
                    tourId: "delegate-routing-rules-tab",
                    isDisabled: element?.subType === 'controller'
                })
            }
    
            tabs.push(
                {
                    label: "User Triggers",
                    tourId: "delegate-user-trigger-tab"
                },
                {
                    label: "Profiles",
                    tourId: "delegate-profiles-tab"
                }
            )
    
            setTabConfig(tabs)
        }
    },[element])

    return (
        <>
            {
                !bottomDrawer &&
                <AppBar position="static">
                    <Tabs value={bottomDrawer ? activeTab : openTab} onChange={(e, v) => { dispatch(setTabOnFocus(v)); setOpenTab(v) }} aria-label="simple tabs example">
                        <Tab label="Delegate" data-ui-tour-id='delegate-tab' />
                        {/* <Tab label="Networks" /> */}
                        <Tab label="Events" data-ui-tour-id='delegate-event-tab' />
                        <Tab label="Transactions" data-ui-tour-id='delegate-transaction-tab' />
                        {!controlDelegate && <Tab label="Routing Rules" disabled={element?.subType === 'controller' ? true : false} data-ui-tour-id='delegate-routing-rules-tab' />}
                        <Tab label="User Triggers" data-ui-tour-id='delegate-user-trigger-tab' />
                        <Tab label="Profile" data-ui-tour-id='delegate-profiles-tab' />
                    </Tabs>
                </AppBar>
            }


            <TabPanel value={bottomDrawer ? activeTab : openTab} index={0} >
                
                {
                    bottomDrawer &&
                    <Box style={{height: '30px'}} />
                }
                {/* <BreadCrumb items={detailsBC} /> */}
                <Grid container direction={"row"} spacing={2}>
                    {
                        !bottomDrawer &&
                        <Grid item xs={8}>
                            <BreadCrumb items={detailsBC} />
                        </Grid>
                    }
                    {!bottomDrawer && !controlDelegate && <Grid item xs={bottomDrawer ? 12 :4} style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Tooltip title={controlDelegate ? "Cannot delete controller delegate" : "Delete Delegate"} >
                            <IconButton disabled={controlDelegate} onClick={() => handleClickDelete()}><DeleteIcon color="secondary" /></IconButton>
                        </Tooltip>
                    </Grid>}

                </Grid>

                <EditDelegate element={element} onCompletion={onCompletion} onClose={() => setAction({})} />

                {action.action === 'delete_delegate' && showDeleteAlert &&
                    <DeleteDelegateAlert onCompletion={onCompletion} setShowDeleteAlert={setShowDeleteAlert} element={element} id={element.id} onClose={() => setAction({})} />
                }
            </TabPanel>

            <TabPanel value={bottomDrawer ? activeTab : openTab} index={1}>
                {
                    bottomDrawer ?
                        <Box style={{height: '5px'}} />
                    :
                    <>
                        <BreadCrumb items={[...detailsBC, { label: 'Events', url: null }]} />
                        <Divider style={marginBottomForBreadCrumb} />
                    </>
                }
                <AllEvents element={element} />
            </TabPanel>

            <TabPanel value={bottomDrawer ? activeTab : openTab} index={2}>
                {
                    bottomDrawer ?
                    <Box style={{height: '5px'}} />
                    :
                    <>
                        <BreadCrumb items={[...detailsBC, { label: 'Transactions', url: null }]} />
                        <Divider style={marginBottomForBreadCrumb} />
                    </>

                }
                <ListTransactions element={element} />
            </TabPanel>

            {!controlDelegate && <TabPanel value={bottomDrawer ? activeTab : openTab} index={3}>
                
            <Box style={{height: '5px'}} />
                <Grid container direction="row" >
                    {
                        !bottomDrawer &&
                        <Grid item xs={8} style={{ display: "flex", justifyContent: "flex-start" }}>
                            <BreadCrumb items={[...detailsBC, ...rrdefItem, ...breadCrumbItem]} />
                        </Grid>
                    }
                    {action.action !== 'create_rrdef' && action.action !== 'edit_rrdef' && isRrdefRequired && !hideCreateRrdfButton && <Grid item xs={bottomDrawer ? 12  :4} style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Tooltip title="Create routing rule">
                            {/* <Button startIcon={<AddCircleOutlinedIcon />} onClick={e => setAction({ action: 'create_rrdef' })} color="primary" variant="contained" style={{ marginLeft: 10, marginBottom: 10 }} > */}
                            <Button onClick={e => setAction({ action: 'create_rrdef' })} color="primary" variant="contained" style={{ marginLeft: 10, marginBottom: 10 }} >
                                Create routing rule
                            </Button>
                        </Tooltip>
                    </Grid>}
                </Grid>

                {
                    !bottomDrawer &&
                    <Divider style={marginBottomForBreadCrumb} />
                }

                {(Object.keys(action).length === 0 || action.action === 'delete_rrdef' ) && <ListRoutingRules isRrdefRequired={isRrdefRequired} element={element} setAction={setAction} />}

                {action.action === 'create_rrdef' && <CreateRoutingRule element={element} onClose={onClose} onCompletion={onCompletion} />}

                {action.action === 'edit_rrdef' && <EditRoutingRule element={element} rrdefId={action.id} onClose={onClose} onCompletion={onCompletion} />}

                {action.action === 'delete_rrdef' && <DeleteRoutingRuleAlert rrdefId={action.id} onClose={onClose} onCompletion={onCompletion} />}

            </TabPanel>}

            <TabPanel value={bottomDrawer ? activeTab : openTab} index={!controlDelegate ? 4 : 3}>
                
                {
                    bottomDrawer &&
                    <Box style={{height: '5px'}} />
                }
                <Grid container direction="row" >
                    {
                        !bottomDrawer &&
                        <Grid item xs={8} style={{ display: "flex", justifyContent: "flex-start" }}>
                            <BreadCrumb items={[...detailsBC, ...userTriggerItem, ...breadCrumbItem]} />
                        </Grid>
                    }
                    {/* <Grid item xs={bottomDrawer ? 12 : 4} style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Tooltip title="Create user trigger">
                            <Button onClick={e => setAction({ action: 'create_user_trigger' })} color="primary" variant="contained" style={{ marginLeft: 10, marginBottom: 10 }} >
                                Create user trigger
                            </Button>
                        </Tooltip>
                    </Grid> */}
                </Grid>
                {
                    !bottomDrawer &&
                    <Divider style={marginBottomForBreadCrumb} />
                }

                {Object.keys(action).length === 0 && <ListUserTriggers element={element} setAction={setAction} />}

                {action.action === 'create_user_trigger' && <CreateUserTrigger element={element} onClose={onClose} onCompletion={onCompletion} />}

                {action.action === 'edit_user_trigger' && <EditUserTrigger userTriggerId={action.id} onClose={onClose} onCompletion={onCompletion} />}

                {action.action === 'delete_user_trigger' && <DeleteUserTriggerAlert userTriggerId={action.id} onClose={onClose} onCompletion={onCompletion} />}

                {/* {action.action === 'extend_fields' && <ExtendFields userTriggerId={action.id} onClose={onClose} onCompletion={onCompletion} />} */}
                {action.action === 'extend_fields' && <ExtendUTFields userTriggerId={action.id} onClose={onClose} onCompletion={onCompletion} />}



            </TabPanel>

            <TabPanel value={bottomDrawer ? activeTab : openTab} index={!controlDelegate ? 5 : 4}>
                
                {
                    bottomDrawer ?
                    <Box style={{height: '20px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: 5}}>
                        {(showGenerateDatabaseProfile && !loading) && 
                            <Grid className={classes.linkContainer} item xs={4}>
                                <Tooltip title={databaseProfileSchema ? "Update database profile with AI" : "Generate database profile with AI"} arrow>
                                            {databaseProfileSchema ? <span
                                                id="ai-regenerate-datasource"
                                                className={classes.icon}
                                                color="primary"
                                                data-ui-tour-id="btn-ai-regenerate-db-profile"
                                                onClick={!isAIAssistantActive ? generateDatabaseTablesWithAI : undefined}
                                                dangerouslySetInnerHTML={{ __html: svgIcons["aiTool"] }}
                                                style={{
                                                    pointerEvents: isAIAssistantActive ? "none" : "auto",
                                                    opacity: isAIAssistantActive ? 0.5 : 1,
                                                    cursor: isAIAssistantActive ? "not-allowed" : "pointer",
                                                    marginRight: 8
                                                }}
                                            /> :
                                            <Link 
                                                data-ui-tour-id="btn-ai-generate-db-profile" 
                                                disabled={isAIAssistantActive}  
                                                style={{
                                                    pointerEvents: isAIAssistantActive ? "none" : "auto",
                                                    opacity: isAIAssistantActive ? 0.5 : 1
                                                }}
                                                component="button" 
                                                onClick={generateDatabaseTablesWithAI} 
                                                className={classes.link} 
                                            > 
                                                Create with AI 
                                            </Link>
                                            }
                                </Tooltip>
                                { databaseProfileSchema &&
                                        <Tooltip title={"Generate database sample data with AI"} arrow>
                                            <span
                                                id="ai-regenerate-datasource"
                                                className={classes.icon}
                                                color="primary"
                                                data-ui-tour-id="btn-ai-generate-db-data"
                                                onClick={!isAIAssistantActive ? generateDatabaseSampleDataWithAI : undefined}
                                                dangerouslySetInnerHTML={{ __html: svgIcons["aiData"] }}
                                                style={{
                                                    pointerEvents: isAIAssistantActive ? "none" : "auto",
                                                    opacity: isAIAssistantActive ? 0.5 : 1,
                                                    cursor: isAIAssistantActive ? "not-allowed" : "pointer"
                                                }}        
                                            />
                                        </Tooltip>  
                                    }
                            </Grid> 
                        }
                    </Box> 
                    :
                    <>
                        <Grid container direction={"row"} spacing={2}>
                            <Grid item xs={8}>
                                <BreadCrumb items={[...detailsBC, { label: 'Delegate Profile', url: null }]} />
                                
                            </Grid>
                            {(showGenerateDatabaseProfile && !loading) && 
                                <Grid className={classes.linkContainer} item xs={4}>
                                    <Tooltip title={databaseProfileSchema ? "Update database profile with AI" : "Generate database profile with AI"} arrow>
                                            {databaseProfileSchema ? <span
                                                id="ai-regenerate-datasource"
                                                className={classes.icon}
                                                color="primary"
                                                data-ui-tour-id="btn-ai-regenerate-db-profile"
                                                onClick={!isAIAssistantActive ? generateDatabaseTablesWithAI : undefined}
                                                dangerouslySetInnerHTML={{ __html: svgIcons["aiTool"] }}
                                                style={{
                                                    pointerEvents: isAIAssistantActive ? "none" : "auto",
                                                    opacity: isAIAssistantActive ? 0.5 : 1,
                                                    cursor: isAIAssistantActive ? "not-allowed" : "pointer",
                                                    marginRight: 8
                                                }}
                                            /> :
                                            <Link 
                                                data-ui-tour-id="btn-ai-generate-db-profile" 
                                                disabled={isAIAssistantActive}  
                                                style={{
                                                    pointerEvents: isAIAssistantActive ? "none" : "auto",
                                                    opacity: isAIAssistantActive ? 0.5 : 1
                                                }}
                                                component="button" 
                                                onClick={generateDatabaseTablesWithAI} 
                                                className={classes.link} 
                                            > 
                                                Create with AI 
                                            </Link>
                                            }
                                    </Tooltip>
                                    { databaseProfileSchema &&
                                        <Tooltip title={"Generate database sample data with AI"} arrow>
                                            <span
                                                id="ai-regenerate-datasource"
                                                className={classes.icon}
                                                color="primary"
                                                data-ui-tour-id="btn-ai-generate-db-data"
                                                onClick={!isAIAssistantActive ? generateDatabaseSampleDataWithAI : undefined}
                                                dangerouslySetInnerHTML={{ __html: svgIcons["aiData"] }}
                                                style={{
                                                    pointerEvents: isAIAssistantActive ? "none" : "auto",
                                                    opacity: isAIAssistantActive ? 0.5 : 1,
                                                    cursor: isAIAssistantActive ? "not-allowed" : "pointer"
                                                }}        
                                            />
                                        </Tooltip>  
                                    }
                                </Grid> 
                            }
                        </Grid>

                        <Divider style={marginBottomForBreadCrumb} />
                    </>
                }
                <DelegateProfile setDatabaseProfileSchema={setDatabaseProfileSchema} loading={loading} setLoading={setLoading} element={element} onCompletion={onCompletion} onClose={() => setAction({})}/>
            </TabPanel>

        </>
    )
}